/**
 * Permanent redirect for the pre-merge editor URL. The surface was deleted in
 * the Phase 4 sweep (the unified studio replaced it), but the URL is in
 * bookmarks, in older emails, and in `?flow=&teach=1&teachStep=` deep links,
 * so it keeps resolving instead of 404ing.
 */
import { Navigate, useLocation, useParams } from 'react-router-dom';

/** /products/:id/flow-studio → /products/:id/studio, query string intact. */
export function FlowStudioRedirect() {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  return <Navigate to={`/products/${id}/studio${search}`} replace />;
}
